/* Copyright 2012 The MathWorks, Inc. */

/**
 * The gallery popup can be rendered in two types of views: Icon and List.
 */
define([], function () {
    return {
        ICON: "icon_view",
        LIST: "list_view"
    };
});